var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageName)?_c('b-img',{ref:"thumb",staticClass:"thumb",attrs:{"id":"thumb","rounded":"","alt":_vm.alt}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }